import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { hook } from '@g4/automation-hooks';
import { VerticalSpacing } from '../../../components/Boneyard';

const propTypes = {
  title: PropTypes.string,
  titleAutomationHook: PropTypes.string,
  children: PropTypes.node,
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Divider = styled.div`
  height: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.section.divider.background};

  ${props => props.theme.query.lg} {
    width: 25%;
  }
`;

const Title = styled.div`
  display: flex;
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  padding-top: ${({ theme }) => theme.spacing(5)};
  width: 100%;
  ${props => props.theme.query.lg} {
    [data-hook='highlighted-deals-title'] {
      margin: 0;
    }
  }
`;

const StyledHeader = styled.h1`
  font-size: 22px;
  font-weight: 500;
`;

const IndexPageSection = ({ title, children, titleAutomationHook }) => (
  <Container>
    <VerticalSpacing size={5} />
    <Divider />

    <Title>
      <StyledHeader {...hook(titleAutomationHook)}>{title}</StyledHeader>
    </Title>

    {children}
  </Container>
);

IndexPageSection.propTypes = propTypes;

export default withTheme(IndexPageSection);
